export default __webpack_public_path__ + "static/media/Exodus_symbol.e6440a57.svg";